const getAccessibilityTypes = [
  { id: 1, name: "Global" },
  { id: 2, name: "Feature" },
];

export default getAccessibilityTypes;
